import { render, staticRenderFns } from "./GroupSurveyPage.vue?vue&type=template&id=0016d678&scoped=true"
import script from "./GroupSurveyPage.vue?vue&type=script&lang=js"
export * from "./GroupSurveyPage.vue?vue&type=script&lang=js"
import style0 from "./GroupSurveyPage.vue?vue&type=style&index=0&id=0016d678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016d678",
  null
  
)

export default component.exports